import {
  Box, Button, Grid, Modal, Stack,
} from '@mui/material';
import { ButtonComponentSettings, ButtonSize } from '../../../models/BlockComponentValues/BlockComponentButton';
import { ColorPickerColors } from '../../../models/ColorPicker';
import ErrorText from '../../ErrorText';
import ButtonColorPicker from './components/ButtonColorPicker';
import ButtonSizePicker from './components/ButtonSizePicker';

interface ButtonSettingsModalProps {
  openModal: boolean;
  settings: ButtonComponentSettings;
  errorText?: string;
  onChangeSize?: (target: ButtonSize) => void;
  onChangeColor?: (target: string | ColorPickerColors) => void;
  onCloseModal: (event: React.MouseEvent) => void;
  onSaveModal: (event: React.MouseEvent) => void;
}

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

function ButtonSettingsModal({
  openModal,
  settings,
  errorText,
  onChangeSize,
  onChangeColor,
  onCloseModal,
  onSaveModal,
}: ButtonSettingsModalProps) {
  return (
    <Modal
      open={openModal}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid
          container
          direction="column"
          alignItems="start"
          justifyContent="center"
          sx={{
            border: '1px dashed lightGray',
            p: 2,
            position: 'relative',
          }}
        >
          <Grid item sx={{ marginBottom: 2 }}>
            <ButtonSizePicker value={settings.size} onChangeSize={(value) => onChangeSize(value)} />
          </Grid>
          <Grid item>
            <ButtonColorPicker value={settings.color} onChangeColor={(value) => onChangeColor(value)} />
          </Grid>
        </Grid>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          mt={2}
        >
          <Button variant="outlined" color="primary" onClick={onCloseModal}>
            キャンセル
          </Button>

          {errorText ? <ErrorText text={errorText} /> : null}

          <Button variant="contained" color="primary" onClick={onSaveModal}>
            適用
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ButtonSettingsModal;
